import React from "react";
import { PrimaryButton } from "@fluentui/react";
import { ButtonVariants } from "../../../styles/fluent/ButtonVariants";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";

interface ObjectsListLockFooterProps {
  disabled?: boolean;
  type?: "lock" | "unlock";
  onToggleLock: () => void;
}

export const ObjectsListLockFooter: React.FC<ObjectsListLockFooterProps> = ({
  disabled = false,
  type = "lock",
  onToggleLock,
}) => {
  return (
    <PrimaryButton
      id={`${type}_button`}
      disabled={disabled}
      className={ButtonVariants.primary}
      styles={{
        label: { whiteSpace: "nowrap" },
      }}
      onClick={onToggleLock}
      text={formatMessage(`cof.base.${type}`).toUpperCase()}
    />
  );
};
